import http from "../../plugins/axios";

export default {
  tree(data) {
    return http.get({
      url: "/la/admin/system/menu/tree",
      data,
    });
  },
  add(data) {
    return http.post({
      url: "/la/admin/system/menu/add",
      data,
    });
  },
  update(data) {
    return http.post({
      url: "/la/admin/system/menu/update",
      data,
    });
  },
  remove(data) {
    return http.post({
      url: "/la/admin/system/menu/delete",
      data,
      dataType: "form",
    });
  },
};
